module.exports = __webpack_public_path__ + "static/media/trash.868a45c4.svg";